// Nhắc ghi đủ ê-kíp (chấm QC bản 3, CEO chốt 4a 19/10/2026).
//
// Đo thật trên đơn: buổi nhiều mặt / nhiều khách thường chỉ ghi MỘT thợ dù hai
// người cùng làm — công và điểm chấm QC khi đó dồn hết cho người được ghi. Bản
// 3 chấm từng người của ê-kíp, nên đơn thiếu tên là bài của người kia không bao
// giờ có. Chỉ nhắc, KHÔNG chặn: một thợ làm nhiều mặt vẫn là chuyện thường.

type CrewMember = { id?: string | null };

/** Từ số mặt trang điểm này trở lên mà một thợ thì nhắc. */
const MAKEUP_FACES_FROM = 2;
/** Từ số người chụp này trở lên mà một thợ chụp thì nhắc. */
const PHOTO_PEOPLE_FROM = 4;

export function crewNudges(o: {
  makeupHeadcount?: number | null;
  headcount?: number | null;
  makeups?: ReadonlyArray<CrewMember> | null;
  photographers?: ReadonlyArray<CrewMember> | null;
}): string[] {
  const out: string[] = [];
  const faces = o.makeupHeadcount ?? 0;
  if (faces >= MAKEUP_FACES_FROM && (o.makeups ?? []).length === 1) {
    out.push(
      `Đơn có ${faces} mặt trang điểm — nếu có thợ thứ hai cùng làm, thêm tên vào ê-kíp để công và điểm chấm tính đúng người.`,
    );
  }
  const people = o.headcount ?? 0;
  if (people >= PHOTO_PEOPLE_FROM && (o.photographers ?? []).length === 1) {
    out.push(
      `Đơn có ${people} người chụp — nếu có thợ chụp thứ hai cùng làm, thêm tên vào ê-kíp để công và điểm chấm tính đúng người.`,
    );
  }
  return out;
}
